module.exports = __webpack_public_path__ + "img/baggrund.b2c3a172.png";